export class RetriableError extends Error { }
export class FatalError extends Error { }
